<mat-toolbar>
  <mat-toolbar-row fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
    <button mat-button [routerLink]="['../../']">
      <mat-icon>keyboard_backspace</mat-icon>
    </button>
    <mat-divider [vertical]="true"></mat-divider>
    <span>{{ 'constructionSite.overview' | translate }}</span>
  </mat-toolbar-row>
</mat-toolbar>

<table mat-table [dataSource]="constructionSites" class="main-content clickable-items-table" #constructionSitesTable>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef class="table-filter-header">
      {{ 'constructionSite.name' | translate }}
      <mat-form-field floatLabel="never">
        <input matInput [formControl]="filterForm.get('name')">
      </mat-form-field>
    </th>
    <td mat-cell *matCellDef="let constructionSite">{{ constructionSite.name }}</td>
  </ng-container>

  <ng-container matColumnDef="transactionId">
    <th mat-header-cell *matHeaderCellDef class="table-filter-header">
      {{ 'constructionSite.transactionId' | translate }}
      <mat-form-field floatLabel="never">
        <input matInput [formControl]="filterForm.get('transactionId')">
      </mat-form-field>
    </th>
    <td mat-cell *matCellDef="let constructionSite">{{ constructionSite.transactionId }}</td>
  </ng-container>

  <ng-container matColumnDef="costcenter">
    <th mat-header-cell *matHeaderCellDef class="table-filter-header">
      {{ 'core.costCenter' | translate }}
      <mat-form-field floatLabel="never">
        <input matInput [formControl]="filterForm.get('costcenter')">
      </mat-form-field>
    </th>
    <td mat-cell *matCellDef="let constructionSite">{{ constructionSite.costcenter }}</td>
  </ng-container>

  <ng-container matColumnDef="active">
    <th mat-header-cell *matHeaderCellDef class="table-filter-header">
      {{ 'core.active' | translate }}
    </th>
    <td mat-cell *matCellDef="let constructionSite">{{ "core." + constructionSite.active.toString() | translate }}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
  <tr mat-row
    *matRowDef="let constructionSite; columns: tableColumns"
    (click)="onConstructionSiteSelected(constructionSite)"
    [routerLink]="['./', constructionSite | objectId, 'tours']"
    [class]="'linked-row'"
  ></tr>
</table>

@if (constructionSitesTable.dataSource.length == 0 ) {
  <app-no-result-message></app-no-result-message>
}

@if (actionPending$ | async) {
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
}
